import { toast } from "react-toastify";
import {
  fetchGetNotificationSuccess,
  fetchGetNotificationFailure,
} from "./reducer";
import { GET_NOTIFICATION } from "../../constants/constants";
import { determineBaseUrlAndPerformApiCall } from "../../interceptor/interceptor";

export const getNotification = () => async (dispatch) => {
  await determineBaseUrlAndPerformApiCall(
    `${GET_NOTIFICATION}?limit=10&page=1`,
    "GET"
  )
    .then((response) => {
      if (!response.error) {
        dispatch(fetchGetNotificationSuccess(response));
        dispatch(setSuccessMessage(true));
      }
      if (response.error) {
        dispatch(fetchGetNotificationFailure(response.error.message));
      }
    })
    .catch((errorResp) => {});
};
